

















































import {Component, Vue} from "vue-property-decorator"
import {Action} from "vuex-class"

@Component
export default class ClientMine extends Vue {

  @Action("api_list_cryptbox_user_device") listUserDevice: Function

  device_list: Object[] = []
  deviceListLoading: boolean = false

  pagination: any = {
    currentPage: 1,
    limit: 20,
    total: 0,
  }

  mounted() {
    let vm = this
    this.$nextTick(async function () {
      vm.init_table_data()
    })
  }

  handlePaginationChange(current: number, size: number) {
    this.pagination.currentPage = current
    this.init_table_data()
  }

  init_table_data() {
    this.deviceListLoading = true
    let params = {
      currentPage: this.pagination.currentPage,
      limit: this.pagination.limit,
      offset: this.pagination.total,
    }
    this.listUserDevice(params).then((res: Ajax.AjaxResponse) => {
      let data: any = res.data
      this.device_list = data.items
      this.pagination.total = data.total
      this.deviceListLoading = false
    }).finally(() => {
      this.deviceListLoading = false
    })
  }
}
